import React, { Component } from 'react';
import { SortingState, IntegratedSorting, PagingState, IntegratedPaging, SearchState, IntegratedFiltering, DataTypeProvider } from '@devexpress/dx-react-grid';
import { Grid, Table, TableHeaderRow, SearchPanel, Toolbar, TableColumnVisibility } from '@devexpress/dx-react-grid-bootstrap4';
import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import ReactDOM from 'react-dom';
import '../../theme/styles/dx-react-grid-bootstrap4.css';
import styles from '../Report/Report.less';
import i18next from 'i18next';
import deliveryStyles from './Delivery.less';
import PropTypes from 'prop-types';
import eyeIconUrl from '../../../static/images/eyeIcon.png';
import eyeIconWhiteUrl from '../../../static/images/eyeIcon-white.png';
import DateSelector from './../DateSelector/DateSelector';
import ReactExport from "react-data-export";
const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
import { connect } from 'react-redux';
import * as commonActions from './../../actions/commonActions';
import { convertEpochToEventTime, getFormattedRate, getMinMaxFractionDigits, setDirection, toEpoch } from './../../utils/utils';
import ViewStatus from './ViewStatus.js';
import moment from 'moment-timezone';
import { getPath } from './../../actions/commonActions';
import * as filesaver from './../../actions/FileSaver.js'
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';

const directionData = [
  { "classNames": "fltrBarInner", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "selectDatebtn", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "reportsTblGrid", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
  { "classNames": "allExportFilter", "elementType": "normal", "applyTo": "all", "tagNames": "div" },
];

const columnsToFormat = { TOTAL_GQ: 'stockQtyFormat', TOTAL_PAMT: 'stockRateFormat' };

const formatExcelValue = (val, row, col) => {

  //Converts array values to a string with line breaks for Excel export
  if (Array.isArray(val)) {
    return {
      value: val.join('\n'),
    };
  }
  const formatStyle = { style: { numFmt: row[columnsToFormat[col.name]] } }
  const value = val === null || val === undefined ? '' : val
  //For other values, return as it is
  if (col.name in columnsToFormat) {
    return { value, ...formatStyle };
  }
  return { value };
};

const NoDataCell = props => (
  <Table.NoDataCell {...props} className="noDataCell" />
);

@connect(
  (state) => ({
    selectedCssColorTheme:
      state.dashboardRoot.commonReducer.selectedCssColorTheme,
    selectedCssColor: state.dashboardRoot.commonReducer.selectedCssColor,
    selectedLang: state.dashboardRoot.commonReducer.selectedLang,
    language: state.dashboardRoot.commonReducer.language,
    userDetail: state.auth.userDetail,
  }),
  {
    ...commonActions,
  }
)
export default class CompletedComponent extends Component {
  static propTypes = {
    selectedCssColor: PropTypes.string,
    showViewModal: false,
    deliveryData: PropTypes.array,
  };

  handleIconClick = (row) => {
    this.setState({ showViewModal: true });
    this.setState({ selectedRow: row });
  };

  closeViewModal = () => {
    this.setState({ showViewModal: false });
  };

  comparePriority = (a, b) => {
    return toEpoch(a) - toEpoch(b);
  };

  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      columns: [
        { name: "DRN", title: i18next.t("deliveryRequestNo") },
        { name: "AD", title: i18next.t("account") },
        { name: "CMDTY", title: i18next.t("cmdty") },
        {
          name: "TOTAL_GQ",
          title: i18next.t("quantity") + " " + this.props.userDetail.CompanyBaseName,
          align: "right",
        },
        {
          name: "TOTAL_FC_PAMT",
          title: i18next.t("premAmt"),
          width: { wpx: 90 },
          align: "left",
        },
        { name: "TOTAL_PAMT", title: i18next.t("premAmt") + " (USD)", align: "right" },
        { name: "LOC_DESC", title: i18next.t("location") },
        { name: "COLLECTIONDATETIME", title: i18next.t("collectionDateTime") },
        { name: "DOCS", title: i18next.t("generatedDocs") },
        { name: "RMK", title: i18next.t("comments") },
        { name: "STATUSDESC", title: i18next.t("status") },
        { name: "TS", title: i18next.t("eventTime") },
        { name: "", title: "", id: "action" },
      ],
      searchValue: "",
      pageSizes: [10, 15, 20, 0],
      keyValue: "completedRequests",
      selectedRow: {},
      showRptDialog: false,
      integratedSortingColumnExtensions: [
        { columnName: "COLLECTIONDATETIME", compare: this.comparePriority },
      ],
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      numericColumns: ["TOTAL_GQ", "TOTAL_PAMT", "TOTAL_FC_PAMT"],
    };
  }

  componentDidMount() {
    const thisComponent = ReactDOM.findDOMNode(this);
    setDirection(thisComponent, directionData, this.props.selectedLang);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.selectedLang !== nextProps.selectedLang) {
      const thisComponent = ReactDOM.findDOMNode(this);
      setDirection(thisComponent, directionData, nextProps.selectedLang);
    }

    if (nextProps.deliveryData !== this.props.deliveryData) {
      const mappedRows = (nextProps.deliveryData || []).map((row) => ({
        ...row,
        AD: row.AC && row.AD ? `${row.AC} - ${row.AD}` : row.AD || "",
        TZ: row.TZ || "",
        COLLECTIONDATETIME:
          [row.DATE, row.TIME, row.NOTATION, row.TZ]
            .filter(Boolean)
            .join(" ") ||
          row.TZ ||
          "",
      }));

      this.setState({ rows: mappedRows });
    }
  }

  afterOpenModal() {
    try {
      const thisComponent = this.refs.errorMSG;
      ////const allCssStyleRules = this.props.selectedCssColorTheme;
      const elementsData = [
        {
          classNames: "closeBtn",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
        {
          classNames: "button-l",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
      ];
      // applyStyle(thisComponent, allCssStyleRules, elementsData);
      const directionData = [
        {
          classNames: "header",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "commonCloseIcon",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "commonMsgDir",
          elementType: "normal",
          applyTo: "all",
          tagNames: "div",
        },
        {
          classNames: "button-l",
          elementType: "normal",
          applyTo: "single",
          tagNames: "button",
        },
      ];
      setDirection(thisComponent, directionData, this.props.selectedLang);
      const hoverElementsClassNames = [
        {
          elmToHover: thisComponent.getElementsByClassName("closeBtn")[0],
          classNames: "closeBtn",
        },
        {
          elmToHover: thisComponent.getElementsByClassName("button-l")[0],
          classNames: "button-l",
        },
      ];
      ////applyToHover(thisComponent, hoverElementsClassNames, allCssStyleRules);
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "afterOpenModal",
        component: "CompletedComponent",
      });
    }
  }

  closeRptModal = (event) => {
    try {
      this.setState({ showRptDialog: false });
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "closeRptModal",
        component: "CompletedComponent",
      });
    }
  };

  changeSearch = (searchValue) => this.setState({ searchValue });

  setStartDate = (startDate) => {
    try {
      const formattedStartDate = moment(startDate, "YYYY/MM/DD").format(
        "DD-MM-YYYY"
      );
      if (
        this.props.onDateChange &&
        this.props.startDate !== formattedStartDate
      ) {
        this.props.onDateChange(formattedStartDate, this.props.endDate);
      }
      this.setState({ startDate: formattedStartDate });
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "setStartDate",
        component: "Delivery",
      });
    }
  };

  setEndDate = (endDate) => {
    try {
      const formattedEndDate = moment(endDate, "YYYY/MM/DD").format(
        "DD-MM-YYYY"
      );
      if (this.props.onDateChange && this.props.endDate !== formattedEndDate) {
        this.props.onDateChange(this.props.startDate, formattedEndDate);
      }
      this.setState({ endDate: formattedEndDate });
    } catch (e) {
      this.props.logFileCreation({
        error: e.message,
        originFunction: "setEndDate",
        component: "Delivery",
      });
    }
  };

  handleSubmit = () => {
    const { startDate, endDate } = this.state;
    if (this.props.onDateChange) {
      this.props.onDateChange(startDate, endDate);
    }
  };

  changeFlag = () => {
    this.setState({ showRptDialog: true });
  };

  generatePdf = (format) => {
    try {
      const startDate = this.state.startDate;
      const endDate = this.state.endDate;
      const user = JSON.parse(localStorage.getItem("user"));
      const platform = localStorage.getItem("platform");
      const region = navigator.language;
      let response = "";
      if (
        this.state.rows.length === 0 ||
        this.state.rows === "" ||
        this.state.rows === null
      ) {
        this.setState({ showRptDialog: true });
      } else if (format === "PDF") {
        var xhr = new XMLHttpRequest();
        xhr.open(
          "GET",
          getPath("api") +
            "/user/generateDeliveryPDF?isTrader=true&type=C&from=" +
            startDate +
            "&to=" +
            endDate
        );
        xhr.setRequestHeader("SID", this.props.userDetail.SID);
        xhr.setRequestHeader("username", this.props.userDetail.UID);
        xhr.setRequestHeader("location", user.location);
        xhr.setRequestHeader("Cache-Control", "no-cache");
        xhr.setRequestHeader("platform", platform);
        xhr.responseType = "blob";
        xhr.onload = function (dispatch) {
          if (xhr.status === 200) {
            filesaver.saveAs(
              xhr.response,
              "Delivery_Completed_Requests_" +
                startDate +
                "_to_" +
                endDate +
                ".pdf"
            );
          } else {
            this.changeFlag();
          }
        }.bind(this);
        xhr.send();
      }
    } catch (err) {
      console.error("Error generating report:", err);
    }
  };

  eventTimeCoverter = ({ value }) => {
    return <span>{convertEpochToEventTime(value)}</span>;
  };

  render() {
    const { rows, columns, searchValue, pageSizes, setStartDate, setEndDate } =
      this.state;

    const multiDataSet = [
      {
        columns: columns.map((col) => ({
          title: col.title,
          width: { wpx: 150 },
        })),
        data: rows.map((row) =>
          columns.map((col) => formatExcelValue(row[col.name], row, col))
        ),
      },
    ];

    const Cell = (props) => {
      const { column, row } = props;

      // Find the column definition so we can see if it has align: 'right'
      const colDef = this.state.columns.find((c) => c.name === column.name);
      const isRightAligned = colDef?.align === "right";

      if (column.id === "action") {
        return (
          <Table.Cell {...props}>
            <img
              className={deliveryStyles.viewIcon}
              src={
                this.props.selectedCssColor === "DR"
                  ? eyeIconWhiteUrl
                  : eyeIconUrl
              }
              onClick={() => this.handleIconClick(row)}
              alt="view"
              width={16}
              height={16}
            />
          </Table.Cell>
        );
      }

      if (column.name === "DOCS") {
        const docs = row[column.name];
        return (
          <Table.Cell {...props}>
            {Array.isArray(docs)
              ? docs.map((doc, idx) => <div key={idx}>{doc}</div>)
              : docs || "-"}
          </Table.Cell>
        );
      }

      return (
        <Table.Cell
          {...props}
          style={{
            textAlign: isRightAligned ? "right" : "left",
            ...props.style,
          }}
        />
      );
    };

    const pagingPanelMessages = {
      showAll: i18next.t("all"),
      rowsPerPage: i18next.t("rowsPerPage"),
      info: "",
    };

    const PagingContainer = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDiv" />
    );
    const PagingContainerdark = (props) => (
      <PagingPanel.Container {...props} className="pagingPanelDivDark" />
    );
    const shouldPage = rows?.length > pageSizes[0];

    const PagingStateComponent = shouldPage ? (
      <PagingState defaultCurrentPage={0} defaultPageSize={pageSizes[0]} />
    ) : null;
    const IntegratedPagingComponent = shouldPage ? <IntegratedPaging /> : null;

    return (
      <div id="completedReqTab" className={`${this.props.language}`}>
        <Modal
          isOpen={this.state.showRptDialog}
          className={styles.warningModal}
          id="pendingRqstsModal"
          onAfterOpen={this.afterOpenModal}
        >
          <div ref="errorMSG" className="mdlWrap">
            <div className={`${styles.header} header`}>
              <span className={`${styles.msgTitle}`}>
                {i18next.t("completedRequests")}
              </span>
              <span
                onClick={this.closeRptModal}
                className={`${styles.closeImg} closeIcon`}
                id="pendingRqstsCloseIcon"
              >
                {this.props.closeIcon}
              </span>
            </div>
            <div className={`${styles.msg} commonMsgDir`}>
              {i18next.t("noDataAvlMsg")}
            </div>
            <div className={`${styles.btnWrap} col-md-12`}>
              <Button
                className="button-l"
                bsStyle="primary"
                onClick={this.closeRptModal}
                id="pendingRqstsCloseBtn"
              >
                {i18next.t("OK")}
              </Button>
            </div>
          </div>
        </Modal>
        <div
          id="completedReqTabFilter"
          className={`${styles.filterBar} filterBar ordhistoryfilterBar ${this.props.selectedCssColor}`}
        >
          <div className={`${styles.filterBarInner} fltrBarInner`}>
            <div
              className={`${styles.filterItem} ordHistoryfiteroptions ordHistDrpdown`}
              id="orderHistorydatetype"
            >
              <div
                className={`${styles.selectDatebtn} ordHistDrpdown`}
                id="trdOnlOrdrptDate"
              >
                <DateSelector
                  keyValue={this.state.keyValue}
                  onClickFilter={this.handleSubmit}
                  setStartDate={this.setStartDate}
                  setEndDate={this.setEndDate}
                  component="DeliveryCompleted"
                  startDate={this.props.startDate}
                  endDate={this.props.endDate}
                />
              </div>
            </div>

            <div
              className={`${styles.exportfileBaracc} exportfileBaracc`}
              id="orderhistoryfiledownload"
            >
              <div id="ordhistorygobtn" className="accfilterItem">
                <button
                  type="button"
                  className={
                    this.state.isRefreshDisabled === true
                      ? `${styles.disabled} ${styles.goBtn}`
                      : `${styles.goBtn}`
                  }
                  onClick={() => this.handleSubmit()}
                  id="delCompletedTabRefreshBtn"
                >
                  {this.props.refreshIcon}
                </button>
              </div>
            </div>
          </div>
          <div
            className={`${styles.exportfileBaracc} ${deliveryStyles.delCompleteExp}`}
          >
            <label
              className={
                this.state.loadtableflag === true ? "disableLabel" : null
              }
            >
              {this.state.rows?.length !== 0 && (
                <span>
                  <ExcelFile
                    filename="DeliveryCompletedRequests"
                    element={<img src="/images/xls.png" />}
                  >
                    <ExcelSheet
                      dataSet={multiDataSet}
                      name="DeliveryCompletedRequests"
                    />
                  </ExcelFile>
                </span> 
              )}
              {this.state.rows?.length === 0 && <img src="/images/xls.png" onClick={this.changeFlag} />}
              <span>
                <img
                  src="/images/pdf.png"
                  onClick={() => {
                    this.generatePdf("PDF");
                  }}
                  id="delCompletedReqPDF"
                />
              </span>
            </label>
          </div>
        </div>
        <div
          className={`${deliveryStyles.deliveryTbl} ${deliveryStyles.deliveryCompTbl} deliveryTbl`}
          id="activitytbl"
        >
          <div className={`reportsTblGrid ${deliveryStyles.completedTabTable}`}>
            <Grid rows={rows} columns={columns}>
              <DataTypeProvider
                for={this.state.numericColumns}
                formatterComponent={({ column, row, value }) => {
                    const config = {
                        TOTAL_GQ: { ...getMinMaxFractionDigits(row.stockQtyFormat), roundOff: row.stockQtyRound },
                        TOTAL_PAMT: { ...getMinMaxFractionDigits(row.stockRateFormat), roundOff: row.stockRateRound },
                        TOTAL_FC_PAMT: { ...getMinMaxFractionDigits(row.stockRateFormat), roundOff: row.stockRateRound }
                    }[column.name] || {};

                    const { minimumFractionDigits, maximumFractionDigits, roundOff } = config;

                  const formattedValue = getFormattedRate(
                    value,
                    minimumFractionDigits,
                    maximumFractionDigits,
                    true,
                    roundOff
                  );

                  if (column.name === "TOTAL_FC_PAMT") {
                    return (
                      <span>
                        {formattedValue}
                        {row.CURRENCY ? ` ${row.CURRENCY}` : " USD"}
                      </span>
                    );
                  }
                  return <span>{formattedValue}</span>;
                }}
              />

              <DataTypeProvider
                for={["TS"]}
                formatterComponent={this.eventTimeCoverter}
              />

              <SortingState
                defaultSorting={[
                  { columnName: "COLLECTIONDATETIME", direction: "desc" },
                ]}
                columnExtensions={[
                  { columnName: "COLLECTIONDATETIME", sortingEnabled: true },
                ]}
              />
              <IntegratedSorting
                columnExtensions={this.state.integratedSortingColumnExtensions}
              />

              {PagingStateComponent}
              {IntegratedPagingComponent}

              <SearchState
                value={searchValue}
                onValueChange={this.changeSearch}
              />
              <IntegratedFiltering />

              <Table
                cellComponent={Cell}
                noDataCellComponent={NoDataCell}
                messages={{ noData: i18next.t("noDataAvlMsg") }}
              />

              <TableHeaderRow showSortingControls />
              <Toolbar />
              <SearchPanel />
              <TableColumnVisibility />

              {shouldPage && (
                <PagingPanel
                  pageSizes={pageSizes}
                  messages={pagingPanelMessages}
                  containerComponent={
                    this.props.selectedCssColor === "DR"
                      ? PagingContainerdark
                      : PagingContainer
                  }
                />
              )}
            </Grid>
          </div>
        </div>
        <ViewStatus
          isOpen={this.state.showViewModal}
          onClose={this.closeViewModal}
          rowData={this.state.selectedRow}
        />
      </div>
    );
  }
}
